import { Namespace } from '../../../translation/namespace';
import i18n from '../../../translation/i18n';

function getExtensionKey(fileExtension?: string): string | null {
  return fileExtension ? `${Namespace.Download}:${fileExtension.toLowerCase()}` : null;
}

function getKeyOrUnknown(key?: string): string {
  if (key && i18n.exists(key)) {
    return i18n.t(key);
  }
  return i18n.t(`${Namespace.Download}:unknown`);
}

export function getFileDescription(fileExtension: string): string {
  const descriptionKey = `${getExtensionKey(fileExtension)}.description`;
  return getKeyOrUnknown(descriptionKey);
}

export function getFileExtensionDescription(fileExtension: string): string {
  const extensionDescriptionKey = `${getExtensionKey(fileExtension)}.extensionDescription`;
  return getKeyOrUnknown(extensionDescriptionKey);
}
